import { wsmenu } from '../../../plugins/ws-menu-v1.0.1/src/js/ws-menu';
import { wsSlideToggle } from 'ws-display-toggle/src';
import wsMediaQuery from 'ws-media-query/src';

// Private Functions
wsMediaQuery.prototype.init = function() {
  let _this = this;
  this.mq();
  window.matchMedia(this.options.mediaQuery).addListener(function(){
      _this.mq();
  });
}

wsMediaQuery.prototype.mq = function() {
  let _this = this;
  if (window.matchMedia(this.options.mediaQuery).matches) {
      this.options.matches();
  } else {
      this.options.unmatches();
  }
}

//WS MENU INIT
document.addEventListener('DOMContentLoaded', function () {
  try {
    var mainNav = new wsmenu({
      addClassNames: true,
      changeToDesktop: 'all and (min-width: 1200px)',
      megaMenu: false,
    });
  } catch (error) {
    console.warn(error);
  }

  try {
    var toggleButton = document.getElementById('header-nav__toggler');
    var toggleTarget = document.getElementById('header-nav');

    var slideToggle = new wsSlideToggle();

    toggleButton.addEventListener('click', function(){
      slideToggle.slideToggle(toggleTarget);
    });

  } catch (error) {
    console.warn(error);
  }
});

try {

  var pageHeader = document.getElementById("page-header");
  var darkLogo = document.getElementById("header-dark-logo");
  var lightLogo = document.getElementById("header-light-logo");

  var headerBranding = new wsMediaQuery({
    mediaQuery: "all and (min-width: 1200px)",
    matches: function () {
      if (pageHeader.classList.contains('header--on-dark')) {
        darkLogo.style.display = "none";
        lightLogo.style.display = "block";
      } else {
        lightLogo.style.display = "none";
        darkLogo.style.display = "block";
      }
    },
    unmatches: function () {
      lightLogo.style.display = "none";
      darkLogo.style.display = "block";
    }
  });
} catch (error) {
  console.warn(error);
}
